import { showToast } from "../components/Toasts";
import WatchableValue from "../models/WatchableValue";

export interface Telegram {
  timestamp: string;
  priority: string;
  sourceAddr: string;
  targetAddr: string;
  hopcount: string;
  medium: string;
  device: string;
  payload: string;
  feedback: string;
  systemBroadcast: string;
  ackRequested: string;
  isRepetition: string;
  structLength: string;
  type: string;
  apciType: string;
  apdu: string;
  asdu: string;
  decodedAsdu: string;
  decodedLteFrame: string;
  dptvalue: string;
  dpttype: string;
}

export interface FoundPhysicalAddressesEntry {
  addr: string;
  mask: string | null;
  time: number;
}

class KnxReadBack {
  gatewayIp: string = "";
  readbackMonitoringIsRunning: boolean = false;
  foundPhysicalAddresses = new Array<FoundPhysicalAddressesEntry>();
  lineScannedAddresses = new Array<FoundPhysicalAddressesEntry>();
  telegrams = new Array<Telegram>();

  watchModified = new WatchableValue(0); // allowing monitoring of changed in th UI
  watchAdded = new WatchableValue(0); // allowing monitoring of changed in th UI

  toastTitle = "";
  toastText = "";
  progress = false;

  // Auto Check
  registerFoundAddr(sourceAddr: any) {
    let i = this.foundPhysicalAddresses.findIndex((i) => i.addr == sourceAddr);
    if (i == 0) {
      return;
    }

    if (i > 0) {
      this.foundPhysicalAddresses.splice(i, 1);
    }

    this.foundPhysicalAddresses.unshift({ addr: sourceAddr, mask: "", time: Date.now() });

    this.watchModified.value = this.watchModified.value + 1;
    if (i < 0) {
      this.watchAdded.value = this.watchAdded.value + 1;
    }
  }

  clearFoundAddrs() {
    this.foundPhysicalAddresses = new Array<FoundPhysicalAddressesEntry>();
    this.watchModified.value++;
    this.watchAdded.value++;
  }

  // Line Scan
  registerScannedAddr(sourceAddr: any) {
    let i = this.lineScannedAddresses.findIndex((i) => i.addr == sourceAddr);
    if (i == 0) {
      return;
    }

    if (i > 0) {
      this.lineScannedAddresses.splice(i, 1);
    }

    this.lineScannedAddresses.unshift({ addr: sourceAddr, mask: "", time: Date.now() });

    this.watchModified.value = this.watchModified.value + 1;
    if (i < 0) {
      this.watchAdded.value = this.watchAdded.value + 1;
    }
  }

  setScannedAddrList(list: Array<FoundPhysicalAddressesEntry>) {
    this.lineScannedAddresses = list;
    this.watchModified.value++;
    this.watchAdded.value++;
  }

  clearScannedAddrs() {
    this.lineScannedAddresses = new Array<FoundPhysicalAddressesEntry>();
    this.watchModified.value++;
    this.watchAdded.value++;
  }

  // Group Monitor
  clearTelegrams() {
    this.telegrams = new Array<Telegram>();
    this.watchModified.value++;
    this.watchAdded.value++;
  }

  registerTelegram(telegram: any) {
    this.telegrams.push({
      timestamp: telegram.timestamp,
      priority: telegram.priority,
      sourceAddr: telegram.sourceAddr,
      targetAddr: telegram.targetAddr,
      hopcount: telegram.hopcount,
      medium: telegram.medium,
      device: telegram.device,
      payload: this.uint8ArrayToHex(telegram.payload),
      feedback: telegram.feedback ? "Positive" : "Negative", // no itx
      systemBroadcast: telegram.systemBroadcast == "true" ? "Yes" : "",
      ackRequested: telegram.ackRequested == "true" ? "Yes" : "",
      isRepetition: telegram.isRepetition == "true" ? "Yes" : "",
      structLength: telegram.structLength,
      type: telegram.type,
      apciType: telegram?.apciType || "",
      apdu: telegram?.apdu || "",
      asdu: telegram?.asdu || "",
      decodedAsdu: telegram?.decodedAsdu || "",
      decodedLteFrame: telegram?.decodedLteFrame || "",
      dptvalue: telegram?.dptvalue || "",
      dpttype: telegram?.dpttype || "",
    });

    this.watchModified.value += 1;
    this.watchAdded.value += 1;
  }

  uint8ArrayToHex(uint8Array) {
    return Array.from(uint8Array)
      .map((byte: any) => byte.toString(16).padStart(2, "0")) // 2-digit hex
      .join(" ")
      .split("-")
      .join(" ");
  }

  // Future: Import and Export Telegrams via Xml file

  // Other Utility functions
  setGatewayIp(ip: string) {
    this.gatewayIp = ip;
  }

  showProgressBar(keepVisible?: boolean) {
    showToast({
      title: this.toastTitle,
      text: this.toastText,
      keepVisible: keepVisible == false ? undefined : true,
      progress: this.progress,
    });
  }

  setToastText(title?: string, text?: string, keepVisible?: boolean) {
    this.toastTitle = title || this.toastTitle;
    this.toastText = text || this.toastText;
    this.showProgressBar(keepVisible);
  }
}

let _knxReadBack: KnxReadBack;
export function knxReadBack() {
  if (!_knxReadBack) {
    _knxReadBack = new KnxReadBack();
  }
  return _knxReadBack;
}
